import { render, staticRenderFns } from "./Events_main_old.vue?vue&type=template&id=79342f29&scoped=true&"
import script from "./Events_main_old.vue?vue&type=script&lang=js&"
export * from "./Events_main_old.vue?vue&type=script&lang=js&"
import style0 from "./Events_main_old.vue?vue&type=style&index=0&id=79342f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79342f29",
  null
  
)

export default component.exports